module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("商品列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加商品")])], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名"
    },
    model: {
      value: (_vm.formInline.name),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "name", $$v)
      },
      expression: "formInline.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类选择",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    on: {
      "change": _vm.categoryChoose
    },
    model: {
      value: (_vm.formInline.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "categoryId", $$v)
      },
      expression: "formInline.categoryId"
    }
  }, _vm._l((_vm.catogreyArr), function(item) {
    return _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创建时间",
      "prop": "dayStart"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptionsStart
    },
    on: {
      "change": _vm.startChange
    },
    model: {
      value: (_vm.formInline.dayStart),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dayStart", $$v)
      },
      expression: "formInline.dayStart"
    }
  }), _vm._v("\n                -\n                "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptionsEnd
    },
    on: {
      "change": _vm.endChange
    },
    model: {
      value: (_vm.formInline.dayEnd),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "dayEnd", $$v)
      },
      expression: "formInline.dayEnd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "条形码编号",
      "prop": "productDetailNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "编号"
    },
    model: {
      value: (_vm.formInline.productDetailNo),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "productDetailNo", $$v)
      },
      expression: "formInline.productDetailNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "default-sort": {
        prop: 'date',
        order: 'descending'
      },
      "element-loading-text": "拼命加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productDetailId",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rental",
      "label": "租金",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deposit",
      "label": "押金",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rentalCount",
      "label": "租赁次数",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productCount",
      "label": "设备数量",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "创建时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "isOnline",
      "label": "商品状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.isOnline) ? _c('span', [_vm._v("上架")]) : _c('span', [_vm._v("下架")])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEquipment(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("设备管理")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), (_vm.Role === '1' && _vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOff(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("下架")]) : _vm._e(), _vm._v(" "), (!_vm.row.isOnline) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleOn(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看库存")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleFreash(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("更新商品统计")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看库存",
      "visible": _vm.dialogTableVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [(_vm.dialogTableVisible) ? _c('vue-event-calendar', {
    attrs: {
      "events": _vm.demoEvents
    },
    on: {
      "day-changed": _vm.dayChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.showEvents), function(event, index) {
          return _c('div', {
            staticClass: "event-wrapper"
          }, _vm._l((event.title), function(item) {
            return _c('div', {
              staticClass: "event-item"
            }, [_vm._v("\n                            " + _vm._s(item.text) + "\n                        ")])
          }), 0)
        })
      }
    }], null, false, 956717776)
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-098c4cd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/ProductList.vue
// module id = 710
// module chunks = 1